import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { HiMenu, HiX, HiLogout } from 'react-icons/hi';
import { useAuth } from '../contexts/AuthContext';
import './Header.css';

export default function Header({ logo, brandName, theme = 'dark' }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate('/login');
  };

  const displayName = user
    ? (user.given_name || user.email || user.username || '').split(' ')[0]
    : null;

  return (
    <header className={`app-header ${theme}`}>
      <div className="header-container">
        <Link to="/" className="brand-link">
          {logo}
          <span className="brand-name">{brandName}</span>
        </Link>

        <nav className={`nav-menu ${mobileMenuOpen ? 'open' : ''}`}>
          <Link to="/" onClick={() => setMobileMenuOpen(false)}>Home</Link>
          <Link to="/schedule" onClick={() => setMobileMenuOpen(false)}>Schedule</Link>
          <Link to="/replays" onClick={() => setMobileMenuOpen(false)}>Replays</Link>
          {user ? (
            <>
              <span className="nav-user">{displayName}</span>
              <button className="nav-signout" onClick={handleSignOut}><HiLogout /></button>
            </>
          ) : (
            <Link to="/login" className="nav-cta" onClick={() => setMobileMenuOpen(false)}>Login</Link>
          )}
        </nav>

        <button
          className="mobile-menu-btn"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <HiX /> : <HiMenu />}
        </button>
      </div>
    </header>
  );
}
